/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAssetTypeDto } from '../models/CreateAssetTypeDto';
import type { UpdateAssetTypeDto } from '../models/UpdateAssetTypeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssetTypesService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Listar tipos de activo (paginado)
   * @returns any Lista de tipos de activo con paginación
   * @throws ApiError
   */
  public assetTypesControllerFindAll({
    page = 1,
    limit = 10,
    search,
    isActive,
    isSystem,
    sortBy = 'name',
    sortOrder = 'asc',
  }: {
    /**
     * Número de página (1-indexed)
     */
    page?: number,
    /**
     * Cantidad de registros por página
     */
    limit?: number,
    /**
     * Búsqueda por nombre o código
     */
    search?: string,
    /**
     * Filtrar por estado activo (true/false)
     */
    isActive?: 'true' | 'false',
    /**
     * Filtrar solo tipos de sistema
     */
    isSystem?: 'true' | 'false',
    /**
     * Campo de ordenamiento (name, code, createdAt)
     */
    sortBy?: string,
    /**
     * Dirección de ordenamiento
     */
    sortOrder?: 'asc' | 'desc',
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/asset-types',
      query: {
        'page': page,
        'limit': limit,
        'search': search,
        'isActive': isActive,
        'isSystem': isSystem,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
      },
      errors: {
        401: `No autenticado`,
      },
    });
  }
  /**
   * Crear nuevo tipo de activo
   * @returns any Tipo de activo creado exitosamente
   * @throws ApiError
   */
  public assetTypesControllerCreate({
    requestBody,
  }: {
    requestBody: CreateAssetTypeDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/asset-types',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos o campos mal configurados`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        409: `Ya existe un tipo de activo con este código`,
      },
    });
  }
  /**
   * Obtener tipo de activo por ID
   * @returns any Detalles del tipo de activo
   * @throws ApiError
   */
  public assetTypesControllerFindOne({
    id,
  }: {
    /**
     * ID del tipo de activo (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/asset-types/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `No autenticado`,
        404: `Tipo de activo no encontrado`,
      },
    });
  }
  /**
   * Actualizar tipo de activo
   * @returns any Tipo de activo actualizado exitosamente
   * @throws ApiError
   */
  public assetTypesControllerUpdate({
    id,
    requestBody,
  }: {
    /**
     * ID del tipo de activo (UUID)
     */
    id: string,
    requestBody: UpdateAssetTypeDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/asset-types/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Tipo de activo no encontrado`,
      },
    });
  }
  /**
   * Eliminar tipo de activo
   * @returns any Tipo de activo eliminado exitosamente
   * @throws ApiError
   */
  public assetTypesControllerRemove({
    id,
  }: {
    /**
     * ID del tipo de activo (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/asset-types/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `No se puede eliminar (es tipo de sistema o tiene activos asociados)`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Tipo de activo no encontrado`,
      },
    });
  }
}
